(() => {
  const prefetched = new Set();
  const blockedPaths = ['/account', '/apps', '/cart', '/checkout', '/search', '/tools'];

  const eligibleUrl = (link) => {
    if (!(link instanceof HTMLAnchorElement) || link.target === '_blank' || link.hasAttribute('download')) return null;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.href === window.location.href) return null;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    if (blockedPaths.some((path) => url.pathname === path || url.pathname.startsWith(`${path}/`))) return null;

    url.hash = '';
    return url.href;
  };

  const prefetch = (link) => {
    const href = eligibleUrl(link);
    if (!href || prefetched.has(href) || navigator.connection?.saveData) return;

    prefetched.add(href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = href;
    document.head.append(hint);
  };

  document.addEventListener('pointerover', (event) => prefetch(event.target.closest?.('a[href]')), {
    passive: true,
    capture: true,
  });
  document.addEventListener('focusin', (event) => prefetch(event.target.closest?.('a[href]')), {
    passive: true,
    capture: true,
  });
  document.addEventListener('touchstart', (event) => prefetch(event.target.closest?.('a[href]')), {
    passive: true,
    capture: true,
  });

  const prefetchVisibleNavigation = () => {
    let count = 0;
    document.querySelectorAll('header a[href], .clog-mobile-nav a[href]').forEach((link) => {
      if (count >= 6) return;
      const rect = link.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        prefetch(link);
        count += 1;
      }
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(prefetchVisibleNavigation, { timeout: 2500 });
  } else {
    window.setTimeout(prefetchVisibleNavigation, 1500);
  }
})();
